import { ConsoleLog } from "@inntechcorp/it-design";
import { INNError, usePostFetch } from "Api/hooks/usePostFetch";
import { AxiosProgressEvent } from "axios";

export type FetchProps = {
  params?   : object,
  queries?  : object,
  apiPath   : string,
  success?  : (result: any) => void,
  error?    : (error?:INNError) => void,
  progress? : (event:AxiosProgressEvent) => void,
  type?     : "post" | "put" | "get"
}

/**
 * 
 * useAPI
 * ---
 * 
 * @description Ekstra özellik gerektirmeyen api çağırmaları için
 * kullanılır. API sorgusu yapmak için `_fetch`, yapılan sorguyu
 * iptal etmek için `_cancel` çağrılır.
 * 
 */
export default function useAPI() {

  const { fetch, cancel } = usePostFetch();

  const onError = (apiPath:string) => {
    ConsoleLog.double("🔴 Unhandled API Call [useAPI]", apiPath, "error");
  }

  /**
   * 
   * CANCEL
   * ---
   * 
   * @description API sorgunu iptal eder.
   * 
   */
  const _cancel = () => {
    cancel();
  };

  /**
   * 
   * FETCH
   * ---
   * 
   * @description API sorgusunu iletilen değerlerle birlikte başlatır. Bu sorgu
   * istenildiği taktirde `_cancel` çağrılarak iptal edilebilir.
   * 
   * @param params    API sorgusuna eklenecek param değerleri objesi.
   * @param queries   API sorgusuna eklenecek query değerleri objesi.
   * @param apiPath   API sorgusunun yapılacak adres.
   * @param success   API sorgusu başarıyla tamamlandığında çağrılır.
   * @param error     API sorgusu iptal edildiğinde çağrılır.
   * 
   */
  const _fetch = async ({
    params    = {},
    queries   = {},
    apiPath   = "",
    success,
    error,
    progress,
    type      = "post"
  }: FetchProps) => {

    await fetch(
      type ? type : "post",
      apiPath,
      params,
      {
        onFetched   : success,
        onError     : (err?:INNError) => {
          if ( error ) {
            error(err);
          }
          else {
            onError(apiPath);
          }
        },
        onProgress  : progress
      },
      queries
    );

  };

  return { _fetch, _cancel };
}
